import AppConfig from '@/app.config.js'
import moment from '@/moment.js'
import router from '@/router.js'

//import api from "@/services/apiService"

import firebase from 'firebase/app'
import 'firebase/auth'

const logout = async function() {
  console.log('logout!!!')
  await localStorage.removeItem(AppConfig.auth.LoggedIn)
  await firebase.auth().signOut()
  router.push({name: 'auth-login'})
}

const getProfile = async () => {
  return new Promise((resolve, reject) => {
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        firebase
        .auth()
        .currentUser
        .getIdToken(true)
        .then(async (idToken)=>{
          // บันทึก token
          await localStorage.setItem(AppConfig.auth.LoggedIn, JSON.stringify({
            token: idToken,
            expire: moment().add(50, 'm').format("YYYY-MM-DD HH:mm:ss")
          }))

          resolve({
            fullname: user.displayName,
            username: user.email,
            role: 'Admin',
            img: user.photoURL,
            token: idToken
          })
        })
      } else {
        // No user is signed in.
        console.log('No user is signed in.')
        reject(null)
      }
    });
  });
}

const getToken = () => {
  try {
    let user = localStorage.getItem(AppConfig.auth.LoggedIn)

    if(!user) {
      throw null
    }

    user = JSON.parse(user)
    //console.log('user', user)
    if(moment().isAfter(user.expire)) {
      throw null
    }

    return user.token
  }
  catch(e) {
    console.log(e)
    return false
  }
}

class AuthService {

  async getToken() {
    let token = getToken()
    if(token) {
      return token
    }else{
      let user = await getProfile()
      if(user) {
        return user.token
      }else{
        return false
      }
    }
  }

  async getProfile() {
    return getProfile()
  }

  async saveLogin() {
    return getProfile()
  }

  isLoggedIn() {
    return localStorage.getItem(AppConfig.auth.LoggedIn)
  }

  logout() {
    logout()
  }

}

export default new AuthService();
